import { useQuery } from "react-query";

import axios from "axios";
import { AUTOMATION_SERVICE_ADDRESS } from "constants/app.constants";
import { arrayOrEmpty } from "utils";

export interface AutomationSchedule {
  _id: string;
  name: string;
  automationId: string;
  owner: string;
  schedule: {
    type: "once" | "daily" | "weekly" | "monthly";
    startDate: string;
    endDate?: string;
    time?: string;
    dayOfWeek?: number;
    dayOfMonth?: number;
  };
  emailTemplate?: {
    subject: string;
    body: string;
    recipients: string[];
  };
  isActive: boolean;
  jobId?: string;
  createdAt: string;
  updatedAt: string;
}

export const AUTOMATION_SCHEDULES_QUERY_KEY = "automationSchedules";

export default function useFetchAutomationSchedules() {
  return useQuery<AutomationSchedule[]>(
    [AUTOMATION_SCHEDULES_QUERY_KEY],
    async () => {
      const response = await axios.get<AutomationSchedule[]>(
        `${AUTOMATION_SERVICE_ADDRESS}/api/schedules`
      );
      return arrayOrEmpty(response.data);
    },
    {
      refetchOnWindowFocus: true,
      refetchInterval: 60000 //every minute
    }
  );
}
